<template>
  <div class="lxm-switch-search">
    <div ref="search" class="lxm-switch-search__search">
      <lxm-search :placeholder="searchPlaceholder"
                  :twoLetters="twoLetters"
                  @submit="submit">
      </lxm-search>
    </div>
    <div ref="summary" class="lxm-switch-search__summary is-clearfix">
      <p class="is-pulled-left">
        <slot></slot>
      </p>
      <img class="lxm-switch-search__search-img is-pulled-right"
           src="../../images/main/search.png"
           @click="searchClicked" />
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-switch-search
    height: siz(42)
    padding-top: spacing-small
  .lxm-switch-search__search
    display: none
    padding: 0 spacing
  .lxm-switch-search__summary
    font-size: size-smaller
    line-height: 1
    padding-top: spacing-big - spacing-small
  .lxm-switch-search__search-img
    width: siz(14) + spacing
    height: siz(14)
    padding-right: spacing
</style>

<script>
  /* global $: false */
  import LxmSearch from './LxmSearch.vue'
  export default {
    components: {
      LxmSearch
    },
    props: {
      searchPlaceholder: String,
      twoLetters: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        searching: false,
        animating: false
      }
    },
    mounted () {
      const hideSearch = (e) => {
        if (this.searching &&
        !this.animating &&
        e.target.className.indexOf('input') < 0 &&
        e.target.className.indexOf('button') < 0 &&
        e.target.className.indexOf('lxm-switch-search') < 0) {
          this.animating = true
          const $search = $(this.$refs.search)
          const $searchInput = $search.find('input')
          const $searchImg = $search.find('img')
          const $summary = $(this.$refs.summary)
          const duration = 300
          $searchImg.animate({ opacity: 0 }, duration, 'swing', () => {
            $searchInput.css('float', 'right')
            $searchInput.animate({ opacity: 0, width: '0%' }, duration, 'swing', () => {
              $search.hide()
              $summary.show()
              $summary.css('opacity', 0)
              $summary.animate({ opacity: 1 }, duration, 'swing', () => {
                this.searching = false
                this.animating = false
                this.$emit('end')
              })
            })
          })
        }
      }
      $('body').off('click', hideSearch)
      $('body').on('click', hideSearch)
    },
    methods: {
      searchClicked () {
        if (!this.searching && !this.animating) {
          this.animating = true
          const $search = $(this.$refs.search)
          const $searchInput = $search.find('input')
          const $searchImg = $search.find('img')
          const $summary = $(this.$refs.summary)
          const duration = 300
          $summary.animate({ opacity: 0 }, duration, 'swing', () => {
            $summary.hide()
            $search.show()
            $searchInput.css('opacity', 0)
            $searchInput.css('width', '0%')
            $searchInput.css('float', 'right')
            $searchImg.css('opacity', 0)
            $searchInput.animate({ opacity: 1, width: '100%' }, duration, 'swing', () => {
              $searchImg.animate({ opacity: 1 }, duration, 'swing', () => {
                this.searching = true
                this.animating = false
              })
            })
          })
        }
      },
      submit (payload) {
        this.$emit('submit', payload)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmSwitchSearch.vue?3523af62